import Dashboard from 'modules/dashboard';
import Subscribers from 'modules/subscribers';
import Transactions from 'modules/transactions';
import MaskNamesContent from 'modules/mask-names';
import UpgradeRequest from 'modules/upgrade-request';
import ForVerification from 'modules/for-verification';

import SubscriptionSettings from 'modules/subscription-settings';
import { AiOutlineDashboard, AiOutlineUser } from 'react-icons/ai';
import { CgArrowsExchange } from 'react-icons/cg';
import { IoSettingsOutline } from 'react-icons/io5';
import { BiMask } from 'react-icons/bi';
import { HiLockOpen, HiOutlineDocumentReport } from 'react-icons/hi';

import BannedWords from 'modules/banned-words';
import RequestContent from 'modules/mask-names/Request';

import UserManagement from 'modules/access-control/user-management/Index';
import RolesAndPermissions from 'modules/access-control/roles-and-permissions/Index';

import Subscriptions from 'modules/mask-names/Subscriptions';
import Reports from 'modules/reports';
import ContentManagement from 'modules/cms';

export const routes = [
  {
    path: 'dashboard',
    component: Dashboard,
    icon: AiOutlineDashboard,
    permissions: ['dashboard'],
  },
  {
    path: 'subscribers',
    component: Subscribers,
    icon: AiOutlineUser,
    withNested: true,
    subRoutes: [
      {
        path: 'dashboard',
        component: Subscribers,
        withNested: true,
        title: 'Subscribers',
        permissions: ['subscriber'],
      },
      {
        path: 'verification-request',
        component: ForVerification,
        withNested: true,
        title: 'verification request',
        permissions: ['subscriber_requirement'],
      },
      {
        path: 'upgrade-plan-request',
        component: UpgradeRequest,
        withNested: true,
        title: 'upgrade plan request',
        permissions: ['subscriber_subscription'],
      },
    ],
  },
  {
    path: 'transactions',
    component: Transactions,
    icon: CgArrowsExchange,
    withNested: true,
    permissions: ['transaction'],
  },
  {
    path: 'mask-names',
    component: MaskNamesContent,
    icon: BiMask,
    withNested: true,
    subRoutes: [
      {
        path: 'masterlist',
        component: MaskNamesContent,
        withNested: true,
        title: 'mask names masterlist',
        permissions: ['sender_name'],
      },
      {
        path: 'request',
        component: RequestContent,
        withNested: true,
        title: 'mask names request',
        permissions: ['sender_name'],
      },
      {
        path: 'subscriptions',
        component: Subscriptions,
        withNested: true,
        title: 'subscriptions',
        permissions: ['sender_name'],
      },
    ],
  },
  {
    path: 'reports',
    component: Reports,
    icon: HiOutlineDocumentReport,
    withNested: false,
    permissions: [],
  },
  {
    path: 'settings',
    component: SubscriptionSettings,
    icon: IoSettingsOutline,
    withNested: true,
    subRoutes: [
      {
        path: 'plans',
        component: SubscriptionSettings,
        withNested: true,
        title: 'plans',
        permissions: ['subscription'],
      },
      {
        path: 'banned-words',
        component: BannedWords,
        withNested: true,
        title: 'banned words',
        permissions: [],
      },
      {
        path: 'content-management',
        component: ContentManagement,
        withNested: true,
        title: 'content management system',
        permissions: ['cms'],
      },
    ],
  },
  {
    path: 'access-control',
    component: UserManagement,
    icon: HiLockOpen,
    withNested: true,
    subRoutes: [
      {
        path: 'user-management',
        component: UserManagement,
        withNested: true,
        title: 'user management',
        permissions: ['user'],
      },
      {
        path: 'roles-and-permissions',
        component: RolesAndPermissions,
        withNested: true,
        title: 'roles and permissions',
        permissions: ['role', 'role_permission', 'user_role', 'permission'],
      },
    ],
  },
];

export default {};
